import { motion, useReducedMotion } from 'framer-motion';
import { ScorePropagation } from '../diagrams/ScorePropagation';
import { Stagger, StaggerItem } from '../motion/Reveal';
import { SectionHeading } from '../ui/SectionHeading';

const highlights = [
  'Individual & team ranking',
  'Live leaderboard',
  'LED / venue display',
  'Public results',
  'Official reports & printing',
  'Competition statistics',
];

export function SolutionSection() {
  const reduce = useReducedMotion();

  return (
    <section id="solution" className="section-pad" aria-labelledby="solution-heading">
      <div className="content-width">
        <SectionHeading
          eyebrow="The AeroJudge way"
          title="Enter the score once."
          id="solution-heading"
          description="When a judge or scorer enters a validated score, AeroJudge can update the competition ecosystem that depends on it — rankings, venue displays, public pages and printable reports."
        />
        <ScorePropagation />
        <Stagger className="mt-6 flex flex-wrap gap-2" stagger={0.05}>
          {highlights.map((item) => (
            <StaggerItem key={item}>
              <motion.div
                className="rounded-full border border-sky/30 bg-sky/10 px-3 py-1.5 text-sm font-medium text-navy"
                whileHover={reduce ? undefined : { y: -2 }}
              >
                {item}
              </motion.div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
